module.exports = __webpack_public_path__ + "img/logo-mobile-green.ff82e59d.svg";